import React from "react";
import ContentCard from "@/components/ContentCard";
import PageLayout from "@/components/PageLayout";

const Privacy = () => {
  return (
    <PageLayout
      title="Privacy Policy"
      description="This page explains the basic data practices for Skadisfinity Layout."
    >
      <ContentCard title="Local Calculator Settings">
        <p>
          Skadisfinity Layout stores calculator preferences such as dimensions,
          selected printer, print profile, and unit preference in your browser
          local storage. This keeps the calculator convenient between visits.
          Those settings are not submitted to a Skadisfinity server.
        </p>
      </ContentCard>

      <ContentCard title="Analytics">
        <p>
          The site may use Cloudflare Web Analytics to understand aggregate
          traffic, page views, and basic performance. This helps identify
          whether the calculator is useful and whether pages load correctly.
        </p>
      </ContentCard>

      <ContentCard title="Advertising">
        <p>
          The site may use Google AdSense after approval. Google and its
          partners may use cookies or similar technologies to serve ads, limit
          repeated ads, and measure ad performance according to Google policies.
        </p>
      </ContentCard>

      <ContentCard title="Contact">
        <p>
          For privacy or project questions, use the public GitHub repository:
          {" "}
          <a
            className="text-blue-600 underline underline-offset-2"
            href="https://github.com/trudrknight/Skadisfinity"
            rel="noreferrer"
            target="_blank"
          >
            github.com/trudrknight/Skadisfinity
          </a>
          .
        </p>
      </ContentCard>
    </PageLayout>
  );
};

export default Privacy;
